import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';

@Component({
    selector: 'app-report-api-url-dialog',
    imports: [Button, Dialog, TextareaModule],
    templateUrl: './report-api-url-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportApiUrlDialogComponent {
    url = input.required<string>();

    /** Two-way binding to control dialog visibility. */
    visible = model<boolean>(false);

    copied = signal(false);

    copyUrl() {
        const text = this.url();

        if (navigator.clipboard) {
            navigator.clipboard.writeText(text)
                .then(() => this.showCopied())
                .catch(() => this.fallbackCopy(text));
        } else {
            this.fallbackCopy(text);
        }
    }

    private fallbackCopy(text: string) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            document.execCommand('copy');
            this.showCopied();
        } finally {
            document.body.removeChild(textarea);
        }
    }

    private showCopied() {
        this.copied.set(true);
        setTimeout(() => this.copied.set(false), 2000);
    }

    close() {
        this.visible.set(false);
    }
}
